import {Asset} from "../../entities/Asset";
import {AssetService} from "../../services/AssetService";
import {MaintenanceHistoryService} from "../../services/MaintenanceHistoryService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {MaintenanceHistory} from "../../entities/MaintenanceHistory";

export class ScheduledMaintenanceModel{
    static $inject = ['$q','AssetService','MaintenanceHistoryService','CustomFieldNameService','NotificationService'];
    selectedAsset:Asset;
    assets:Asset[];
    search: string = "";
    locationName: string = "";
    locationSite: string = "";
    afterDate:Date = null;
    beforeDate:Date = null;
    notes:string;
    performedBy:string;
    action: string;
    regularMaintenance: boolean = true;
    errorMessage:string = "";
    constructor(public $q:ng.IQService,
                public assetService:AssetService,
                public maintenanceHistoryService:MaintenanceHistoryService,
                public customFieldNameService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }
    getAssets():ng.IPromise<void>{
      var afterDateStr:string = this.afterDate == null ? "" : this.afterDate.toUTCString();
        var beforeDateStr: string = this.beforeDate == null ? "" : this.beforeDate.toUTCString();
        return this.assetService.getByMaintenance(this.search, this.locationName, this.locationSite, afterDateStr, beforeDateStr).then((data) => {
            this.assets = data;
            return this.$q.when();
        });
    }
    getMaintenanceHistories(assetId:number):ng.IPromise<any>{
        return this.maintenanceHistoryService.getByAsset(assetId);
    }
    validate():boolean{
        this.errorMessage = "";
        if (this.action == null || this.action.length ==0)
            this.errorMessage = "Please enter an action before saving.";
        return this.errorMessage.length == 0;
    }
    save():ng.IPromise<void>{
        if (this.validate()) {
            var mh: MaintenanceHistory = new MaintenanceHistory(null, this.selectedAsset.id, null, this.action, this.notes, this.performedBy, this.regularMaintenance);
            return this.maintenanceHistoryService.insert(mh).then((data)=>{
                this.notifyService.notify("Maintenance History inserted successfully");
            });
        }
        else
            return this.$q.resolve();
    }
    getColumnDefs():ng.IPromise<[string,string,number][]>{
        return this.customFieldNameService.getAssetColumnDefs();
    }
}
